<div id="google_translate_element" style="display: none"></div>
<div class="banner d-flex align-items-center">
  <img aria-hidden="true" class="image" src="/assets/bannerimage.png" alt="Commonwealth of Pennsylvania" />
  <a href="#" (click)="openPagovDialog($event)">Official website</a>
  of the Commonwealth of Pennsylvania
</div>
<div class="app-header">
  <div class="app-header-left">
    <a class="home-link" href="#" (click)="navigateToDashboard($event)">Home</a>
    <div class="logo">
      <a href="#" (click)="navigateToDashboard($event)">
        <img src="assets/logo-with-text.svg" alt="Commonwealth of Pennsylvania" />
      </a>
    </div>
  </div>
  @if (!isMobile()) {
    <div class="app-header-center">
      <button mat-stroked-button [matMenuTriggerFor]="langMenu" class="language-button">
        <mat-icon>language</mat-icon>
        Translate
      </button>

      <mat-menu #langMenu="matMenu" class="skiptranslate">
        <button mat-menu-item (click)="translate('ar')">Arabic</button>
        <button mat-menu-item (click)="translate('bn')">Bengali</button>
        <button mat-menu-item (click)="translate('zh-CN')">Chinese (Simplified)</button>
        <button mat-menu-item (click)="translate('zh-TW')">Chinese (Traditional)</button>
        <button mat-menu-item (click)="translate('en')">English</button>
        <button mat-menu-item (click)="translate('fr')">French</button>
        <button mat-menu-item (click)="translate('de')">German</button>
        <button mat-menu-item (click)="translate('gu')">Gujarati</button>
        <button mat-menu-item (click)="translate('ht')">Haitian Creole</button>
        <button mat-menu-item (click)="translate('it')">Italian</button>
        <button mat-menu-item (click)="translate('km')">Khmer</button>
        <button mat-menu-item (click)="translate('ko')">Korean</button>
        <button mat-menu-item (click)="translate('ne')">Nepali</button>
        <button mat-menu-item (click)="translate('pl')">Polish</button>
        <button mat-menu-item (click)="translate('pt')">Portuguese (Brazil)</button>
        <button mat-menu-item (click)="translate('ru')">Russian</button>
        <button mat-menu-item (click)="translate('es')">Spanish</button>
        <button mat-menu-item (click)="translate('vi')">Vietnamese</button>
      </mat-menu>
    </div>
    <div class="app-header-right d-flex justify-content-around">
      @if (authService.isAuthenticated()) {
        <div class="welcome-wrapper">
          <div class="welcome">
            <span>Welcome Back,</span>
          </div>
          <span id="name">{{ authService.currentUser()?.firstName }}</span>
        </div>
        <div class="separator"></div>
        <div class="profile">
          @let initials = (authService.currentUser()!.firstName | slice: 0 : 1) + (authService.currentUser()!.lastName | slice: 0 : 1);
          <a mat-icon-button class="profile-icon" href="#" [attr.aria-label]="initials + ' Profile Icon'" (click)="$event.preventDefault()">
            <span class="initials" aria-hidden="true">{{ initials }}</span>
          </a>
        </div>

        <div class="logout">
          <button type="button" aria-label="Log out" id="logout-btn" (click)="onLogout()">Logout</button>
        </div>
      } @else {
        <div class="actions">
          <mat-form-field subscriptSizing="dynamic">
            <mat-select placeholder="Register / Login" panelClass="panel" aria-label="Registration and Login" (selectionChange)="onLoginRegistartion($event)">
              <mat-option value="Citizen" aria-label="Consumer">Consumer</mat-option>
              <mat-option value="BusinessPartner" aria-label="Business Partner">Business Partner</mat-option>
              <mat-option value="CWOPA" aria-label="DHS Staff">DHS Staff</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
  }
</div>

<ng-template #pagovDialogTemplate>
  <div class="dialog-header-wrapper">
    <button class="dialog-close-btn d-flex align-items-center justify-content-center" mat-dialog-close aria-label="Close dialog">
      <mat-icon fontSet="material-icons-outlined" aria-hidden="true">close</mat-icon>
    </button>

    <div class="dialog-title-container d-flex flex-column align-items-center justify-content-center">
      <mat-icon fontSet="material-icons-outlined" class="title-icon" aria-hidden="true">account_balance</mat-icon>
      <h2 mat-dialog-title id="dialog-title" class="centered-title">The .gov means it's official.</h2>
    </div>
  </div>

  <mat-dialog-content>
    <div class="dialgoue-content">
      <p>
        Local, state, and federal government websites often end in .gov. Commonwealth of Pennsylvania government websites and email systems use "pennsylvania.gov" or "pa.gov" at
        the end of the address. Before sharing sensitive or personal information, make sure you're on an official state website.
      </p>
    </div>
  </mat-dialog-content>
</ng-template>
